import { render } from "./SearchQuestionView.vue?vue&type=template&id=ba604c10"
import script from "./SearchQuestionView.vue?vue&type=script&lang=js"
export * from "./SearchQuestionView.vue?vue&type=script&lang=js"

import "./SearchQuestionView.vue?vue&type=style&index=0&id=ba604c10&lang=scss"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__